import React from "react";
import chatSauvage from "../assets/pictures/chatSauvage.png";
import jouetChat from "../assets/pictures/jouetchat.png";
import "../styles/Page404.css";

const Page404 = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  let url = `${apiUrl}`;
  return (
    <div className="container404">
      <p className="message1">
        Oh nooon ! vous vous êtes perdu et Mysti404 vous attaque !
      </p>
      <div className="chatonSauvage">
        <img
          className="imgChaton"
          src={chatSauvage}
          alt="chat qui sort ces griffes"
        />
        <div className="message404">
          <p className="error">Erreur 404</p>
          <p className="cliquezVite">
            Cliquez vite sur son jouet pour le calmer et retourner a l'accueil
            !{" "}
          </p>
        </div>
      </div>
      <a href={"/"}>
        <img
          className="souris"
          src={jouetChat}
          alt="jouet pour calmer le chat"
        />
      </a>
    </div>
  );
};

export default Page404;
